module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Tools/Hummer-58ad089b1c7a3441508f2ac3770b8a94.svg";